<template>
	<section class="cd-homework">
		<div class="cd-homework__title">{{ $t('checking_homework') }}</div>
		<div class="cd-homework__content">
			<div class="cd-homework__leftbar filters-leftbar filters-leftbar--bordered">
				<h2 class="filters-leftbar__main-title">{{ $t('filters') }}</h2>
				<div class="filters-leftbar__section">
					<h3 class="filters-leftbar__title">{{ $t('status') }}</h3>
					<ul class="filters-leftbar__list">
						<li v-for="(status, index) in homeworkStatuses"  :key="'status_' + index">
							<label class="checkbox checkbox--small mb-10">
								<input
									type="checkbox"
									class="checkbox__input"
									:value="status"
									v-model="homeworkStatusesModel"
								>
								<span class="checkbox__label">
	      							{{ $t(`homework_statuses.${status}`) }}
	      							<span v-if="attemptsCountByStatus[status] !== undefined">({{ attemptsCountByStatus[status] }})</span>
	    						</span>
							</label>
						</li>
					</ul>
				</div>
				<div class="filters-leftbar__section filters-leftbar__section--top-bordered">
					<h3 class="filters-leftbar__title">Тип попытки</h3>
					<ul class="filters-leftbar__list">
						<li v-for="(type, index) in attemptTypes" :key="'type_' + index">
							<label class="checkbox checkbox--small mb-10">
								<input
									type="checkbox"
									class="checkbox__input"
									:value="type"
									v-model="attemptTypesModel"
								>
					<span class="checkbox__label">
						{{ attemptTypeLabels[type] }}
						<span v-if="attemptsCountByType[type] !== undefined">({{ attemptsCountByType[type] }})</span>
					</span>
							</label>
						</li>
					</ul>
				</div>
				<div class="filters-leftbar__section filters-leftbar__section--top-bordered">
					<h3 class="filters-leftbar__title">Компания</h3>
					<div class="company-filter">
						<div class="company-filter__search">
							<input
								type="text"
								class="company-filter__input"
								placeholder="Поиск компании..."
								v-model="companySearchQuery"
							>
						</div>
						<div class="company-filter__actions mb-10">
							<button
								type="button"
								class="company-filter__action-btn"
								@click="selectAllFilteredCompanies"
							>
								Выбрать все
							</button>
							<button
								type="button"
								class="company-filter__action-btn"
								@click="deselectAllCompanies"
							>
								Снять все
							</button>
						</div>
						<div class="company-filter__list">
							<label
								v-for="(company, index) in filteredCompanies"
								:key="'company_' + index"
								class="checkbox checkbox--small mb-10"
							>
								<input
									type="checkbox"
									class="checkbox__input"
									:value="company"
									v-model="companiesModel"
								>
								<span class="checkbox__label company-filter__label">
									<span class="company-filter__name" :title="company">{{ company }}</span>
									<span class="company-filter__count">({{ attemptsCountByCompany[company] || 0 }})</span>
								</span>
							</label>
						</div>
						<div v-if="companiesModel.length > 0" class="company-filter__selected mt-10">
							<small>Выбрано: {{ companiesModel.length }}</small>
						</div>
					</div>
				</div>
				<div class="filters-leftbar__section filters-leftbar__section--top-bordered">
					<h3 class="filters-leftbar__title">Проверяет</h3>
					<div class="company-filter">
						<div class="company-filter__search">
							<input
								type="text"
								class="company-filter__input"
								placeholder="Поиск проверяющего..."
								v-model="reviewerSearchQuery"
							>
						</div>
						<div class="company-filter__actions mb-10">
							<button
								type="button"
								class="company-filter__action-btn"
								@click="selectAllFilteredReviewers"
							>
								Выбрать все
							</button>
							<button
								type="button"
								class="company-filter__action-btn"
								@click="deselectAllReviewers"
							>
								Снять все
							</button>
						</div>
						<div class="company-filter__list">
							<label
								v-for="(reviewer, index) in filteredReviewers"
								:key="'reviewer_' + index"
								class="checkbox checkbox--small mb-10"
							>
								<input
									type="checkbox"
									class="checkbox__input"
									:value="reviewer"
									v-model="reviewersModel"
								>
								<span class="checkbox__label company-filter__label">
									<span class="company-filter__name" :title="reviewer">{{ reviewer }}</span>
									<span class="company-filter__count">({{ attemptsCountByReviewer[reviewer] || 0 }})</span>
								</span>
							</label>
						</div>
						<div v-if="reviewersModel.length > 0" class="company-filter__selected mt-10">
							<small>Выбрано: {{ reviewersModel.length }}</small>
						</div>
					</div>
				</div>
				<div class="filters-leftbar__section filters-leftbar__section--top-bordered">
					<label class="checkbox checkbox--small mb-10">
						<input
							type="checkbox"
							class="checkbox__input"
							v-model="homeworkCompletedModel"
						>
						<span class="checkbox__label">{{ $t('hide_completed_homework_attempts') }}</span>
					</label>
					<label class="checkbox checkbox--small mb-10">
						<input
							type="checkbox"
							class="checkbox__input"
							v-model="overdueOnlyModel"
						>
						<span class="checkbox__label">Показать просроченные ДЗ</span>
					</label>
				</div>
				<div class="filters-leftbar__section filters-leftbar__section--top-bordered">
					<button @click="resetFilters" class="small-btn white-btn" type="button">{{ $t('buttons.clear_filters') }}</button>
				</div>
			</div>
			<div class="cd-homework__main">
				<label class="cd-homework__search labeled-field labeled-field--search mb-10">
					<input @input="searchOnInput" ref="searchInput" placeholder="Поиск" type="text" class="labeled-field__input" v-model="searchModel">
					<button @click="clearSearch" ref="clearSearchButton" class="remove-btn remove-btn--tiny remove-btn--red hide" type="button"></button>
				</label>
				<div class="cd-homework__table-wrap">
					<table class="table table--tr-hover table--statistics table--homework">
						<thead class="table__thead">
							<tr class="table__tr">
								<th class="table__th" @click="sortTextColumn('status_with_translate', $event)" data-sorted="">
									<span>Статус ДЗ</span>
								</th>
								<th class="table__th" @click="sortTextColumn('attempt_type_label', $event)" data-sorted="">
									<span>Тип попытки</span>
								</th>
								<th class="table__th" @click="sortTextColumn('program', $event)" data-sorted="">
									<span>Программа</span>
								</th>
								<th class="table__th" @click="sortTextColumn('name', $event)" data-sorted="">
									<span>Название ДЗ</span>
								</th>
								<th class="table__th" @click="sortTextColumn('company', $event)" data-sorted="">
									<span>Компания</span>
								</th>
								<th class="table__th" @click="sortTextColumn('student', $event)" data-sorted="">
									<span>Студент</span>
								</th>
								<th class="table__th" @click="sortTextColumn('reviewer', $event)" data-sorted="">
									<span>Проверяет</span>
								</th>
								<th class="table__th" @click="sortTextColumn('cross_checker', $event)" data-sorted="">
									<span>Кроссчекает</span>
								</th>
								<th class="table__th" @click="sortNumericColumn('days_on_review', $event)" data-sorted="">
									<span>Дней на проверке</span>
								</th>
							</tr>
						</thead>
						<tbody class="table__body">
							<template v-if="filteredHomeworkAttempts.length">
								<tr
									v-for="attempt in filteredHomeworkAttempts"
									@click="goToShowPage(attempt.id)"
									class="table__tr"
									:class="{ overdue: isOverdue(attempt) }"
								>
									<td class="table__td">
										<span class="icon icon--small icon--dot" :style="`--icon-color: ${getStatusColor(attempt.status)};`">
											{{ attempt.status_with_translate }}
										</span>
									</td>
									<td class="table__td">
										<span class="bold-font">{{ attempt.attempt_type_label }}</span>
										<template v-if="attempt.previous_reviewer_email">
											<br>
											<span class="table__note">
												Предыдущий проверяющий:
												<a :href="`mailto:${attempt.previous_reviewer_email}`">{{ attempt.previous_reviewer_email }}</a>
											</span>
										</template>
									</td>
									<td class="table__td">
										<span class="bold-font">{{ attempt.program }}</span>
									</td>
									<td class="table__td">
										<span class="bold-font">{{ attempt.name }}</span>
									</td>
									<td class="table__td">
										{{ attempt.company }}
									</td>
									<td class="table__td">
										<a :href="`mailto:${attempt.student}`">{{ attempt.student }}</a>
									</td>
									<td class="table__td">
										<template v-if="attempt.reviewer">
											<a :href="`mailto:${attempt.reviewer}`">{{ attempt.reviewer }}</a>
										</template>
									</td>
									<td class="table__td">
										<template v-if="attempt.cross_checker">
											<a :href="`mailto:${attempt.cross_checker}`">{{ attempt.cross_checker }}</a>
										</template>
									</td>
									<td class="table__td">
										{{ attempt.days_on_review }}
									</td>
								</tr>
							</template>
							<template v-else>
								<tr>
									<td colspan="7" class="table__no-result">
										{{ $t('messages.no_filters_message') }}
									</td>
								</tr>
							</template>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'HomeworkAttempts',

	props: {
		homework_attempts: { type: Array }
	},

	mounted() {
		this.homeworkAttempts = this.getHomeworkAttempts();
	},

	data() {
		return {
					homeworkAttempts: [],
					homeworkStatuses: ['sent', 'checking', 'wait_crosscheck', 'in_crosscheck', 'recheck', 'success_done', 'failed_done', 'archived'],
					homeworkStatusesModel: [],
					attemptTypes: ['first_attempt', 'rework'],
					attemptTypesModel: [],
					attemptTypeLabels: {
						first_attempt: 'Первая попытка',
						rework: 'Доработка'
					},
					homeworkCompletedModel: false,
					searchModel: '',
					overdueOnlyModel: false,
					companiesModel: [],
					companySearchQuery: '',
					reviewersModel: [],
					reviewerSearchQuery: '',
				}
	},

	computed: {
		filteredHomeworkAttempts() {
			let attempts = this.homeworkAttempts;

			if (this.searchModel.length !== 0) {
				let query = this.searchModel.toLowerCase();

				attempts = attempts.filter((attempt) => {
					return (
						attempt.name.toLowerCase().includes(query) ||
						attempt.program.toLowerCase().includes(query) ||
						attempt.status_with_translate.toLowerCase().includes(query) ||
						attempt.attempt_type_label.toLowerCase().includes(query) ||
						attempt.company.toLowerCase().includes(query) ||
						attempt.student.toLowerCase().includes(query) ||
						attempt.reviewer.toLowerCase().includes(query) ||
						attempt.cross_checker.toLowerCase().includes(query) ||
						attempt.previous_reviewer_email.toLowerCase().includes(query)
					)
				})
			}

			if (this.homeworkStatusesModel.length !== 0) {
				attempts = attempts.filter(
					(attempt) => this.homeworkStatusesModel.includes(attempt.status)
				)
			}

			if (this.attemptTypesModel.length !== 0) {
				attempts = attempts.filter(
					(attempt) => this.attemptTypesModel.includes(attempt.attempt_type)
				)
			}

			if (this.homeworkCompletedModel) {
				attempts = attempts.filter(
					(attempt) => attempt.status !== 'success_done'
				)
			}

			if (this.overdueOnlyModel) {
				attempts = attempts.filter((attempt) => this.isOverdue(attempt));
			}

			if (this.companiesModel.length !== 0) {
				attempts = attempts.filter(
					(attempt) => this.companiesModel.includes(attempt.company)
				)
			}

			if (this.reviewersModel.length !== 0) {
				attempts = attempts.filter(
					(attempt) => attempt.reviewer && this.reviewersModel.includes(attempt.reviewer)
				)
			}

			return attempts;
		},

		attemptsCountByStatus() {
			const counts = {};
			this.homeworkStatuses.forEach(status => counts[status] = 0);
			this.homeworkAttempts.forEach(attempt => {
				if (counts.hasOwnProperty(attempt.status)) {
					counts[attempt.status]++;
				}
			});
			return counts;
		},

		attemptsCountByType() {
			const counts = {};
			this.attemptTypes.forEach(type => counts[type] = 0);
			this.homeworkAttempts.forEach(attempt => {
				if (counts.hasOwnProperty(attempt.attempt_type)) {
					counts[attempt.attempt_type]++;
				}
			});
			return counts;
		},

		availableCompanies() {
			const companies = new Set();
			this.homeworkAttempts.forEach(attempt => {
				if (attempt.company && attempt.company.trim() !== '') {
					companies.add(attempt.company);
				}
			});
			return Array.from(companies).sort();
		},

		attemptsCountByCompany() {
			const counts = {};
			this.homeworkAttempts.forEach(attempt => {
				if (attempt.company && attempt.company.trim() !== '') {
					counts[attempt.company] = (counts[attempt.company] || 0) + 1;
				}
			});
			return counts;
		},

		filteredCompanies() {
			if (!this.companySearchQuery.trim()) {
				return this.availableCompanies;
			}
			const query = this.companySearchQuery.toLowerCase();
			return this.availableCompanies.filter(company =>
				company.toLowerCase().includes(query)
			);
		},

		availableReviewers() {
			const reviewers = new Set();
			this.homeworkAttempts.forEach(attempt => {
				if (attempt.reviewer && attempt.reviewer.trim() !== '') {
					reviewers.add(attempt.reviewer);
				}
			});
			return Array.from(reviewers).sort();
		},

		attemptsCountByReviewer() {
			const counts = {};
			this.homeworkAttempts.forEach(attempt => {
				if (attempt.reviewer && attempt.reviewer.trim() !== '') {
					counts[attempt.reviewer] = (counts[attempt.reviewer] || 0) + 1;
				}
			});
			return counts;
		},

		filteredReviewers() {
			if (!this.reviewerSearchQuery.trim()) {
				return this.availableReviewers;
			}
			const query = this.reviewerSearchQuery.toLowerCase();
			return this.availableReviewers.filter(reviewer =>
				reviewer.toLowerCase().includes(query)
			);
		},
	},

	methods: {
		getHomeworkAttempts() {
			let arr = [];

			this.homework_attempts.forEach((attempt) => {
				let obj = {}
				obj.id = attempt.id
				obj.status = attempt.status ?? '';
				obj.status_with_translate = attempt.status_with_translate ? attempt.status_with_translate.text : '';
				obj.attempt_type = attempt.attempt_type ?? 'first_attempt';
				obj.attempt_type_label = attempt.attempt_type === 'rework' ? 'Доработка' : 'Первая попытка';
				obj.previous_reviewer_email = attempt.previous_reviewer_email ?? '';
				obj.program = attempt.user && attempt.user.company && attempt.user.company.prescriptions.length ? attempt.user.company.prescriptions[0].name : '';
				obj.name = attempt.homework && attempt.homework.lecture && attempt.homework.lecture.course
					? attempt.homework.lecture.course.name
					: '';
				obj.company = attempt.user ? attempt.user.company.name : '';
				obj.student = attempt.user ? attempt.user.email : '';
				obj.reviewer = attempt.reviewer ? attempt.reviewer.email : '';
				obj.cross_checker = attempt.cross_checker ? attempt.cross_checker.email : '';
				obj.days_on_review = attempt.created_at ? this.calculateDaysOnReview(attempt.created_at).toString() : '';
				arr.push(obj);
			});

			return arr;
		},

		calculateDaysOnReview(createdAt) {
			return Math.ceil((new Date() - new Date(createdAt)) / (1000 * 60 * 60 * 24));
		},

		goToShowPage(attemptId) {
			window.location.href = `/dashboard/homework_attempts/${attemptId}`;
		},

		getStatusColor(status) {
			switch(status) {
				case 'sent':
					return 'hsl(320, 90%, 50%)';
				case 'checking':
					return 'hsl(280, 90%, 50%)';
				case 'wait_crosscheck':
					return 'hsl(60, 90%, 40%)';
				case 'in_crosscheck':
					return 'hsl(220, 90%, 50%)';
				case 'recheck':
					return 'hsl(180, 90%, 50%)';
				case 'success_done':
					return 'hsl(120, 90%, 40%)';
				case 'failed_done':
					return 'hsl(20, 90%, 50%)';
				case 'archived':
					return 'hsl(210, 90%, 50%)';
				default:
					return 'hsl(120, 90%, 20%)';
			}
		},

		sortTextColumn(column, e) {
			let el = e.currentTarget;

			if (el.dataset.sorted !== 'desc') {
			this.homeworkAttempts = this.homeworkAttempts.sort((a, b) => a[column].localeCompare(b[column]));
				el.dataset.sorted = 'desc';
				el.classList.add('selected');
				el.classList.remove('down');
			} else {
				this.homeworkAttempts = this.homeworkAttempts.sort((b, a) => a[column].localeCompare(b[column]));
				el.dataset.sorted = 'asc';
				el.classList.add('selected');
				el.classList.add('down');
			}
		},

		sortNumericColumn(column, e) {
			let el = e.currentTarget;

			if (el.dataset.sorted !== 'desc') {
				this.homeworkAttempts = this.homeworkAttempts.sort((a, b) => Number(a[column]) - Number(b[column]));
				el.dataset.sorted = 'desc';
				el.classList.add('selected');
				el.classList.remove('down');
			} else {
				this.homeworkAttempts = this.homeworkAttempts.sort((a, b) => Number(b[column]) - Number(a[column]));
				el.dataset.sorted = 'asc';
				el.classList.add('selected');
				el.classList.add('down');
			}
		},

		resetFilters() {
			this.homeworkStatusesModel = [];
			this.attemptTypesModel = [];
			this.companiesModel = [];
			this.companySearchQuery = '';
			this.reviewersModel = [];
			this.reviewerSearchQuery = '';
			this.homeworkCompletedModel = false;
			this.overdueOnlyModel = false;
		},

		selectAllFilteredCompanies() {
			this.filteredCompanies.forEach(company => {
				if (!this.companiesModel.includes(company)) {
					this.companiesModel.push(company);
				}
			});
		},

		deselectAllCompanies() {
			this.companiesModel = [];
		},

		selectAllFilteredReviewers() {
			this.filteredReviewers.forEach(reviewer => {
				if (!this.reviewersModel.includes(reviewer)) {
					this.reviewersModel.push(reviewer);
				}
			});
		},

		deselectAllReviewers() {
			this.reviewersModel = [];
		},


		searchOnInput() {
			if (this.searchModel.length) {
				this.$refs.clearSearchButton.classList.remove('hide');
			} else {
				this.$refs.clearSearchButton.classList.add('hide');
			}
		},

		clearSearch() {
			this.$refs.searchInput.value = '';
			this.searchModel = '';
			this.$refs.clearSearchButton.classList.add('hide');
		},

		isOverdue(attempt) {
			const overdueStatuses = ['sent', 'checking', 'wait_crosscheck', 'in_crosscheck', 'recheck'];
			return overdueStatuses.includes(attempt.status) && Number(attempt.days_on_review) > 10;
		}
	}
}
</script>

<style scoped>
.table__tr.overdue {
  color: #d9534f;
  font-weight: bold;
}

.company-filter {
  width: 100%;
}

.company-filter__search {
  margin-bottom: 10px;
}

.company-filter__input {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid var(--border-color, #ddd);
  border-radius: 5px;
  font-size: 13px;
  font-family: var(--app-font-family-base, inherit);
  background-color: var(--white, #fff);
  color: var(--light-font, #333);
  box-sizing: border-box;
}

.company-filter__input:focus {
  outline: none;
  border-color: var(--action, #007bff);
}

.company-filter__actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.company-filter__action-btn {
  padding: 4px 8px;
  font-size: 12px;
  border: 1px solid var(--border-color, #ddd);
  border-radius: 3px;
  background-color: var(--white, #fff);
  color: var(--light-font, #666);
  cursor: pointer;
  transition: all 0.2s;
}

.company-filter__action-btn:hover {
  background-color: var(--dark-bg, #f0f0f0);
  border-color: var(--action, #007bff);
  color: var(--action, #007bff);
}

.company-filter__list {
  max-height: 200px;
  overflow-y: auto;
  padding-right: 5px;
  margin-bottom: 10px;
}

.company-filter__list::-webkit-scrollbar {
  width: 6px;
}

.company-filter__list::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background-color: hsla(0, 0%, 0%, 0.2);
}

.company-filter__list::-webkit-scrollbar-track {
  background-color: transparent;
}

.company-filter__label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.company-filter__name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 5px;
}

.company-filter__count {
  flex-shrink: 0;
  color: var(--light-font, #999);
  font-size: 11px;
}

.company-filter__selected {
  padding-top: 10px;
  border-top: 1px solid var(--border-color, #eee);
  color: var(--light-font, #666);
  font-size: 12px;
}
</style>
